import { GraviGrid } from '@gravitate-js/excalibrr'
import React, { useCallback, useEffect, useMemo, useRef } from 'react'
import { orderColumnDefs } from '@components/OrderDispatch/OptimizerWizard/columnDefs/orderColumnDefs'

export const UnassignedGrid = ({ rowData, loading }) => {
  const columnApiRef = useRef(null)

  useEffect(() => {
    if (rowData && columnApiRef.current) {
      columnApiRef.current.applyColumnState({
        state: [{ colId: 'run_out', sort: 'asc' }],
        defaultState: { sort: null },
      })
    }
  }, [rowData, columnApiRef])
  const getRowId = useCallback((row) => row?.data?.id, [])
  const columnDefs = useMemo(() => orderColumnDefs(), [])
  const agPropOverrides = useMemo(() => ({ columnDefs: orderColumnDefs(false), getRowId }), [])

  return (
    <GraviGrid
      storageKey={'optimizer-wizard-unassigned-orders'}
      loading={loading}
      rowData={rowData}
      agPropOverrides={agPropOverrides}
      columnDefs={columnDefs}
    />
  )
}
